import store from '../../store'
import moment from 'moment'
import { merge } from 'lodash'
import PGSHelper from '../../helpers/PGSHelper.js';

export default class Mesero {
    static typeSearch      = "local" //online || local

    constructor(data = null) {
        this.Id                 = (data?.Id)?data.Id:null;
        this.Activo             = (data?.Activo)?data.Activo:"";
        this.Tenant             = (data?.Tenant)?data.Tenant:store.getters.getFirebaseApp.tenant;
        this.Deptos             = (data?.Deptos)?data.Deptos:{},
        this.Nombre             = (data?.Nombre)?data.Nombre:"";
        this.ESup               = (data?.ESup)?data?.ESup:null;
    }

    static getPropertyModel(){
        return this;
    }

    static getMeseros(){

    }



}